export default __webpack_public_path__ + "static/media/ChaseIO_Body.26e316a4.jpg";